import type { IconSvgElement } from "@hugeicons/react"

export const googleIcon: IconSvgElement = [
  [
    "path",
    {
      fill: "#EA4335",
      d: "M12 4.75c1.77 0 3.36.61 4.61 1.8l3.43-3.43C17.95 1.19 15.24 0 12 0 7.31 0 3.26 2.69 1.28 6.61l3.99 3.1C6.21 6.86 8.87 4.75 12 4.75z",
    },
  ],
  [
    "path",
    {
      fill: "#4285F4",
      d: "M23.49 12.28c0-.79-.07-1.54-.19-2.28H12v4.51h6.47c-.29 1.48-1.13 2.74-2.39 3.59l3.87 3c2.26-2.09 3.54-5.18 3.54-8.82z",
    },
  ],
  [
    "path",
    {
      fill: "#FBBC05",
      d: "M5.27 14.3c-.24-.72-.38-1.5-.38-2.3s.14-1.57.38-2.3L1.28 6.61C.46 8.73 0 10.56 0 12c0 1.94.46 3.77 1.28 5.39l3.99-3.09z",
    },
  ],
  [
    "path",
    {
      fill: "#34A853",
      d: "M12 24c3.24 0 5.97-1.07 7.95-2.91l-3.87-3c-1.08.73-2.46 1.15-4.08 1.15-3.13 0-5.79-2.11-6.74-4.96l-3.99 3.09C3.26 21.31 7.31 24 12 24z",
    },
  ],
]
